<template>
  <div :class="b(mods)" :style="rootStyles">
    <div
      v-for="(option, index) in optionsVisible"
      :key="index"
      :class="b('option', { short: option.length < 2 })"
      :style="optionStyles(index)"
    >
      <span :class="b('option-text')">
        {{ option }}
      </span>
    </div>
  </div>
</template>

<script src="./units.scripts.js" />

<style module src="./units.styles.scss" lang="scss" />
